import { BulkCandidatesWizardContainer } from '@/features/jobs/job-bulk-candidates/BulkCandidatesWizardContainer';

/** EU-552 — wizard de reprovação em massa (porta de entrada: Gestão de vaga). */
export default function JobRejectCandidatesPage() {
  return <BulkCandidatesWizardContainer variant="reject" />;
}
